import http from "../../common/services/httpService";
import {Api, apiUrls, PaginationParams, SortingAndFilteringParams} from "../../helpers/api";
import {AxiosResponse} from "axios";
import {PageableModel} from "../../common/models/table";
import {NewTicketModel, TicketDetailModel, TicketModel} from "../models/ticket";
import {RelationType} from "../models/relation";
import {HttpErrorModel} from "../../common/models/httpError";
import {TransportationFilters} from "../models/transport";

export class TicketService {
    private static baseUrl = apiUrls.transportation.transportation;

    public static async getAllTickets(filters: TransportationFilters, paginationParams: PaginationParams, sortingAndFilteringParams: SortingAndFilteringParams, search: string): Promise<AxiosResponse<PageableModel<TicketModel>>> {
        const regNo = search && `,regNo_:${search}`;
        sortingAndFilteringParams.filterCondition = `relationType::${RelationType.TICKET_EXPORT}${this.getQuery(filters)}${regNo}`;

        const url = Api.addSortingAndFilteringParams(Api.getUrl(this.baseUrl), sortingAndFilteringParams);

        return await http.get(`${Api.addPaginationParams(url, paginationParams)}`);
    }

    public static async getTicket(id: string): Promise<AxiosResponse<TicketDetailModel>> {
        return await http.get(`${Api.getUrl(this.baseUrl)}/${id}`);
    }

    public static async allowOrNotAllowLocation(ticketId: string, locationId: string, allow: boolean): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        const urlSuffix = allow ? "allow" : "disallow";

        return await http.post(`${Api.getUrl(apiUrls.place.entryOrExit)}/${locationId}/${urlSuffix}/${ticketId}`);
    }

    public static async addTicket(data: NewTicketModel): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.post(Api.getUrl(this.baseUrl), data);
    }

    public static async modifyTicket(data: NewTicketModel, id: string): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.post(`${Api.getUrl(this.baseUrl)}/order/${id}/update`, data);
    }

    private static getQuery(filters: TransportationFilters) {
        const status =  filters.status && `,status::${filters.status}`;
        const ferryEntityId = filters.ferryEntityId && `,ferry.entityId::${filters.ferryEntityId}`;
        const createdAt = `${(filters.dateOfRegistrationFrom && `,createdAt>=${filters.dateOfRegistrationFrom}`)}` + (filters.dateOfRegistrationTo && `,createdAt<=${filters.dateOfRegistrationTo}`);
        const arrivalDepartureTime = filters.arrivalDepartureTime && `,arrivalDepartureTime::${filters.arrivalDepartureTime}`;

        return createdAt + status + ferryEntityId + arrivalDepartureTime;
    }

    public static async scanBarcode(barcodeNo: string): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.post(`${Api.getUrl(this.baseUrl)}/${barcodeNo}/enter-port`);
    }
}
